import React, { useEffect, useRef, useState } from 'react';
import './indexHeaderBar.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDown, faFilePdf, faPlus, faSearch, faStar, faUp, faCircle } from '@fortawesome/pro-solid-svg-icons'
import { Col, Container, Row, Nav, NavDropdown, Navbar } from 'react-bootstrap';
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import { useTranslation } from 'react-i18next';
import { SecurityDetailServiceApi, AttachmentApi } from '../../../../services/actionHub/api';
import { Configuration } from '../../../../services/actionHub/configuration';
import { APIControl } from '../../../../helpers/APIControl';
import { useDispatch, useSelector } from 'react-redux';
import { Toast } from 'primereact/toast';
import WatchlistAddModal from '../../../../components/watchlistComponents/watchlistAddModal';
import Blinker from '../../../../components/blinker/Blinker';
import NumberFormatter from '../../../../formatters/NumberFormatter';
import Streaming from '../../../../services/_realtime/price/Streaming';
import { setIndexBarDetail } from '../../../../stores/security';

const IndexHeaderBar = (props) => { // props: selectedIndex , 
    const attachmentApi = new AttachmentApi(new Configuration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
    const securityDetailServiceApi = new SecurityDetailServiceApi(new Configuration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
    const dispatch = useDispatch();

    const token = useSelector((state) => state.auth?.token);
    const [indexDetail, setIndexDetail] = useState(null);
    const [watchlistAddModalData, setWatchlistAddModalData] = useState(null);
    const [secuirtyStreamProps, setSecuirtyStreamProps] = useState(null);
    const [isDataLoading, setIsDataLoading] = useState(true); // Veri yükleme durumunu takip etmek için eklenen bayrak
    const [isPDFSpinnerShow, setIsPDFSpinnerShow] = useState(false);
    const toast = useRef(null);
    const { t, i18n } = useTranslation();
    const streamingUnSub = useRef(null);
    const stream = useRef(null);
    const numberFormatter = useRef(null);
    const language = i18n.language;

    useEffect(() => {
        stream.current = new Streaming();
        numberFormatter.current = new NumberFormatter();
    }, []);

    useEffect(() => {
        if (indexDetail) {
            dispatch(
                setIndexBarDetail(
                    indexDetail
                )
            )
        }

    }, [indexDetail])

    useEffect(() => {
        if (props.selectedIndex && props.selectedIndex !== null && props.selectedIndex !== undefined) {
            console.log('props.selectedIndex', props.selectedIndex);
            // İlk değerleri ayarlarken veri yükleniyor durumunu true olarak işaretliyoruz
            setIsDataLoading(true);
            setSecuirtyStreamProps({ objectId: props.selectedIndex, lastPrice: 0, dailyChange: 0, direction: faCircle });
            populateSecurityDEtails();
            subscribeToSecurity();
        }
        return () => {
            if (streamingUnSub.current) {
                streamingUnSub.current.Dispose();
            }
        }
    }, [props.selectedIndex]);

    const subscribeToSecurity = () => {

        streamingUnSub.current = stream.current.subscribe({ objectIds: [props.selectedIndex] }, (data) => {
            //console.log(data);
            processStreamingData(data);
        });

    }

    const processStreamingData = (msg) => {
        var cmd = msg['@'];

        if (cmd == undefined) return;

        if (cmd == 'heartbeat')
            return;

        setSecuirtyStreamProps((prev) => {

            let item = prev;
            let newItem = null;
            if (item.objectId === msg["@"]) {

                const newLastPrice = 'lastPrice' in msg ? numberFormatter.current.formatNumber(msg.lastPrice, 2) : msg.lastPrice;
                const newDailyChange = 'dailyChange' in msg ? parseFloat(msg.dailyChange).toFixed(2) : item.dailyChange;
                const newDailyChangePrice = 'dailyChangePrice' in msg ? parseFloat(msg.dailyChangePrice).toFixed(2) : item.dailyChangePrice;
                const isPricePositive = parseFloat(newDailyChangePrice) > 0;
                const isIncreasedDailyChangePrice = parseFloat(newDailyChangePrice) > 0;
                const isDecreasedDailyChangePrice = parseFloat(newDailyChangePrice) < 0;
                const newAsk = 'ask' in msg ? parseFloat(msg.ask).toFixed(2) : item.ask;
                const newBid = 'bid' in msg ? parseFloat(msg.bid).toFixed(2) : item.bid;
                const newDailyHigh = 'dailyHigh' in msg ? numberFormatter.current.formatNumber(msg.dailyHigh, 2) : item.dailyHigh;
                const newDailyLow = 'dailyLow' in msg ? numberFormatter.current.formatNumber(msg.dailyLow, 2) : item.dailyLow;
                const newDailyVolume = 'dailyVolume' in msg ? numberFormatter.current.Double(msg.dailyVolume, 0) : item.dailyVolume;
                const newLastTradeTime = 'lastTradeTime' in msg ? msg.lastTradeTime : item.lastTradeTime;
                const newLastUpdateDate = 'lastUpdateDate' in msg ? msg.lastUpdateDate : item.lastUpdateDate;

                newItem = {
                    ...item,
                    ask: newAsk,
                    bid: newBid,
                    dailyHigh: newDailyHigh,
                    dailyLow: newDailyLow,
                    dailyVolume: newDailyVolume,
                    lastTradeTime: newLastTradeTime,
                    lastUpdateDate: newLastUpdateDate,
                    dailyChangePrice: newDailyChangePrice,
                    lastPrice: newLastPrice,
                    dailyChange: newDailyChange,
                    direction: isIncreasedDailyChangePrice ? faUp : (isDecreasedDailyChangePrice ? faDown : faCircle),
                    changeColor: isPricePositive ? 'green' : 'red'
                };
            }
            else {
                newItem = item;
            }

            return newItem;
        });

        // İlk gerçek veri alındığında yükleme durumunu false olarak işaretle
        setIsDataLoading(false);
    }


    //#region API CALLS

    const populateSecurityDEtails = () => {
        const culture = language;

        securityDetailServiceApi.actionhubIndexdetailGet(token, props.selectedIndex, culture).then((response) => {
            // console.log("actionhubIndexdetailGet: ", response.data);
            if (response.data.detail.length > 0) {
                setIndexDetail(response.data.detail[0]);

                setWatchlistAddModalData(response.data.detail[0]);
                response.data.detail[0].Code = response.data.detail[0].code;
            }
        }
        ).catch((error) => {
            // console.log(error);
        });

    }

    //#endregion 



    const downloadPDF = () => {
        setIsPDFSpinnerShow(true);
        let selectedSecUniqueCode = props.selectedIndex;

        if (!selectedSecUniqueCode) {
            toast.current.show({ severity: 'error', summary: t('error'), detail: t('pleaseSelectAStock'), life: 3000 });
            return;
        }

        attachmentApi.attachmentDownloadPdfGet(token, selectedSecUniqueCode).then((response) => {


            var blob = new Blob([response.data], { type: 'application/pdf' });
            var fileName = selectedSecUniqueCode.replace(":", "_") + '.pdf';

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();

            setTimeout(() => {
                setIsPDFSpinnerShow(false);
            }, 1000);
        }).catch((error) => {
            // console.log(error);
        });

    }

    const watchlistAddModalDataEffect = (data) => {
        // console.log("watchlistAddModalDataEffect: ", data);
    }


    return (
        <>
            <div className='symbol-bar m-t-30'>
                <Toast ref={toast} position='bottom-right' />

                <div className='symbol-bar-code-item '>
                    <Row>
                        <Col lg='12'>
                            {/* <FontAwesomeIcon icon={faSearch} className='search-icon' /> */}
                            {/* 
                            <label className='security-name'>
                                {indexDetail && indexDetail && (indexDetail.code + " - " + indexDetail.Name)}
                            </label> */}

                            {indexDetail ? (
                                <label className='security-name'>
                                    {indexDetail.Name}
                                </label>
                            ) : (
                                <div className='security-name-loading'>
                                    <FontAwesomeIcon icon={faSpinnerThird} spin className='spinner-icon' />
                                </div>
                            )}


                        </Col>
                        {/* <Col lg='12' className='security-desc'>
                            {indexDetail && indexDetail?.Name}
                        </Col> */}
                    </Row>
                </div>

                <div className='symbol-bar-item '>
                    {secuirtyStreamProps && !isDataLoading ? (
                        <>
                            <FontAwesomeIcon
                                icon={secuirtyStreamProps?.direction}
                                className={secuirtyStreamProps?.direction == faUp ? 'up-icon' : secuirtyStreamProps?.direction == faDown ? 'down-icon' : 'none-icon'} />

                            <label className={`security-price `}>
                                {secuirtyStreamProps?.lastPrice}₺
                            </label>
                            <label className={`percent-change ${secuirtyStreamProps?.changeColor}`} >
                                {secuirtyStreamProps?.dailyChangePrice} (%{secuirtyStreamProps?.dailyChange})
                            </label>
                        </>
                    ) : (
                        <div className='dynamic-data-loading'>
                            <FontAwesomeIcon icon={faSpinnerThird} spin className='spinner-icon' />
                            <span className="loading-text"> </span>
                        </div>
                    )}
                </div>

                <div className='button-item '>
                    <Container>
                        <Row className='buttons-row'>
                            {/* <Col lg='6' md='12' sm='12' xs='12' className='pdf-button'>
                                <FontAwesomeIcon icon={isPDFSpinnerShow ? faSpinnerThird : faFilePdf} spinPulse={isPDFSpinnerShow} className='pdf-icon' onClick={downloadPDF} />
                            </Col> */}

                            <Col lg='6' md='12' sm='12' xs='12' className='m-auto watchlist-button'>
                                {/* <FontAwesomeIcon icon={faStar} className='star-icon' /> */}
                                <WatchlistAddModal from={'stockAnalysis'} data={watchlistAddModalData} watchlistAddModalDataEffect={watchlistAddModalDataEffect} />
                            </Col>

                        </Row>
                    </Container>
                </div>

            </div>

            <div className='symbol-update-info-bar'>
                <div className='item'>
                    <label className='text'>
                        {t('stockAnalysis.infoBar.lastUpdate')}<span className="colon-space">: </span>
                        {secuirtyStreamProps && !isDataLoading ? (
                            `${secuirtyStreamProps?.lastUpdateDate} ${secuirtyStreamProps?.lastTradeTime}`
                        ) : (
                            <FontAwesomeIcon icon={faSpinnerThird} spin className='spinner-icon-small' />
                        )}
                    </label>
                </div>

                <div className='divider item'></div>

                <div className='item'>
                    <label className='text'>
                        {t('stockAnalysis.infoBar.volume')}<span className="colon-space">: </span>
                        {secuirtyStreamProps && !isDataLoading ? (
                            <Blinker value={secuirtyStreamProps?.dailyVolume}>
                                {secuirtyStreamProps?.dailyVolume}
                            </Blinker>
                        ) : (
                            <FontAwesomeIcon icon={faSpinnerThird} spin className='spinner-icon-small' />
                        )}
                    </label>
                </div>

                <div className='divider item'></div>

                <div className='item'>
                    <label className='text'>
                        {t('stockAnalysis.infoBar.dayRange')}<span className="colon-space">: </span>
                        {secuirtyStreamProps && !isDataLoading ? (
                            <>
                                <Blinker value={secuirtyStreamProps?.dailyLow} direction="down">
                                    {secuirtyStreamProps?.dailyLow}
                                </Blinker>
                                {" - "}
                                <Blinker value={secuirtyStreamProps?.dailyHigh} direction="up">
                                    {secuirtyStreamProps?.dailyHigh}
                                </Blinker>
                            </>
                        ) : (
                            <FontAwesomeIcon icon={faSpinnerThird} spin className='spinner-icon-small' />
                        )}
                    </label>
                </div>

                {/* <div className='divider item'></div> */}

                {/* <div className='item'>
                    <label className='text'>
                        {t('stockAnalysis.infoBar.buySell')}: 
                        {secuirtyStreamProps && !isDataLoading ? (
                            `${secuirtyStreamProps?.bid} / ${secuirtyStreamProps?.ask}`
                        ) : (
                            <FontAwesomeIcon icon={faSpinnerThird} spin className='spinner-icon-small' />
                        )}
                    </label>
                </div> */}
            </div>
        </>
    );
}

export default IndexHeaderBar;

// Path: src/pages/market/indexAnalysis/components/indexHeaderBar.jsx